/* Soutian (stn) — carousels + CTA scroll-to-buy-box */
(function(){
  if(window.__stnInit) return; window.__stnInit=true;

  /* ---- scroll every [data-stn-scroll] CTA to the buy-box quantity selector ---- */
  function buyTarget(){
    return document.getElementById('stn-buy')
        || document.querySelector('.quantity-break, quantity-breaks, .quantity-breaks-container, .product-form__quantity, variant-selects, .product-form');
  }
  function goBuy(){
    var el=buyTarget(); if(!el) return;
    var y=el.getBoundingClientRect().top + window.pageYOffset - 80;
    if(y<0) y=0;
    try{ window.scrollTo({top:y,behavior:'smooth'}); }catch(e){ window.scrollTo(0,y); }
    /* preview-pane fallback: object-form smooth is ignored there → force numeric */
    setTimeout(function(){ if(Math.abs(window.pageYOffset-y)>8) window.scrollTo(0,y); },90);
  }
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-stn-scroll]'); if(!t) return;
    e.preventDefault(); goBuy();
  });

  /* ---- carousels ---- */
  function initCaro(root){
    var track=root.querySelector('.stn-track'); if(!track) return;
    var cards=Array.prototype.slice.call(track.children);
    var prev=root.querySelector('[data-stn-prev]'), next=root.querySelector('[data-stn-next]');
    var dotsWrap=root.querySelector('.stn-dots'); var dots=[];
    function perView(){
      var c=cards[0]; if(!c) return 1;
      var st=getComputedStyle(track);
      var gap=parseFloat(st.columnGap||st.gap)||16;
      var cw=c.getBoundingClientRect().width+gap;
      var tw=track.clientWidth+gap;
      return Math.max(1, Math.round(tw/cw));
    }
    function pages(){ return Math.max(1, cards.length-perView()+1); }
    function cur(){
      var c=cards[0]; if(!c) return 0;
      var w=c.getBoundingClientRect().width+16;
      return Math.round(track.scrollLeft/w);
    }
    if(dotsWrap){
      dotsWrap.innerHTML='';
      for(var i=0;i<pages();i++){ var b=document.createElement('button');
        b.className='stn-dot'+(i===0?' on':''); b.setAttribute('aria-label','Avis '+(i+1));
        (function(idx){ b.addEventListener('click',function(){ scrollTo(idx); }); })(i);
        dotsWrap.appendChild(b); dots.push(b);
      }
    }
    function scrollTo(idx){
      var c=cards[idx]; if(!c) return;
      var left=c.offsetLeft - track.offsetLeft;
      try{ track.scrollTo({left:left,behavior:'smooth'}); }catch(e){ track.scrollLeft=left; }
      setTimeout(function(){ if(Math.abs(track.scrollLeft-left)>10) track.scrollLeft=left; },80);
      update(idx);
    }
    function update(idx){
      if(idx==null) idx=cur();
      dots.forEach(function(d,i){ d.classList.toggle('on',i===idx); });
      if(prev) prev.disabled = idx<=0;
      if(next) next.disabled = idx>=pages()-1;
    }
    if(prev) prev.addEventListener('click',function(){ scrollTo(Math.max(0,cur()-1)); });
    if(next) next.addEventListener('click',function(){ scrollTo(Math.min(pages()-1,cur()+1)); });
    var tmo; track.addEventListener('scroll',function(){ clearTimeout(tmo); tmo=setTimeout(function(){update();},120); });
    window.addEventListener('resize',function(){ if(dotsWrap){ /* rebuild dot count */ } update(); });
    update(0);
  }
  /* ---- reviews pagination ---- */
  function initPager(list){
    var per = parseInt(list.getAttribute('data-per'),10) || 5;
    var items = Array.prototype.slice.call(list.querySelectorAll('.stn-rev'));
    var pager = (list.parentNode || document).querySelector('.stn-revpager');
    if(!pager || items.length<=per){ if(pager) pager.style.display='none'; return; }
    var pages = Math.ceil(items.length/per), cur=0;
    function mk(label,onclick,disabled,active){
      var b=document.createElement('button');
      b.className='stn-pg'+(active?' on':'');
      b.textContent=label; if(disabled) b.disabled=true;
      if(onclick) b.addEventListener('click',onclick);
      return b;
    }
    function go(i){ if(i<0||i>pages-1||i===cur) return; cur=i; render(true); }
    function render(scroll){
      items.forEach(function(it,i){ it.style.display=(i>=cur*per && i<(cur+1)*per)?'':'none'; });
      pager.innerHTML='';
      pager.appendChild(mk('‹',function(){go(cur-1);},cur===0));
      var start=Math.max(0,Math.min(cur-2,pages-5)), end=Math.min(pages,start+5);
      for(var i=start;i<end;i++){ (function(i){ pager.appendChild(mk(String(i+1),function(){go(i);},false,i===cur)); })(i); }
      pager.appendChild(mk('›',function(){go(cur+1);},cur===pages-1));
      pager.appendChild(mk('»',function(){go(pages-1);},cur===pages-1));
      if(scroll){ var y=list.getBoundingClientRect().top+window.pageYOffset-90; if(y<0)y=0;
        try{window.scrollTo({top:y,behavior:'smooth'});}catch(e){window.scrollTo(0,y);}
        setTimeout(function(){ if(Math.abs(window.pageYOffset-y)>8) window.scrollTo(0,y); },90); }
    }
    render(false);
  }

  function boot(){
    document.querySelectorAll('[data-stn-caro]').forEach(initCaro);
    document.querySelectorAll('[data-stn-revpaginate]').forEach(initPager);
  }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
})();
